import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0da06190&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0da06190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da06190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da06190')) {
      api.createRecord('0da06190', component.options)
    } else {
      api.reload('0da06190', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0da06190&scoped=true&", function () {
      api.rerender('0da06190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jfjZTL3VBS3q/JS/comp/GuestBox.vue"
export default component.exports